// extracted by mini-css-extract-plugin
export default {"secondary":"smallerdashboard_secondary__+J7O6","primary":"smallerdashboard_primary__eDKgn"};